'use strict';

/**
 * Init Preload Logic
 */
class TWER_PRELOADER {


  $preloader = null;
  $counter = null;

  constructor() {

    this.$preloader = document.getElementsByClassName('twer-preloader');
    this.$counter = document.querySelectorAll('.twer-preloader .loading-progress');

    if(!TWER.data.boundaries) {

      this.initPreloader();
    }
      TWER.map.on('idle', (e) => {
        if(!TWER.data.boundaries) {
          // HIDE Preloader when map idle
          this.hide();
        }
      });




  }

  initPreloader() {

    if (this.$preloader.length > 0) {

      let plr = 0;


      if (plr === 0) {
        plr = 1;
        let percent = 1;
        const id = setInterval(() => {
          let maxPercent = Math.floor(Math.random() * (99 - 95 + 1) + 95);
          if (percent >= maxPercent) {
            clearInterval(id);
            plr = 0;
          } else {
            percent++;
            if(this.$counter.length > 0) {
              this.$counter[0].innerHTML = `${percent}%`;
            }
          }
        }, 10);
      }

    }
  }

  hide() {
    if (this.$preloader.length > 0) {
      setTimeout(()=>{
        this.$preloader[0].classList.add('twer-preloader--hide');
      }, 500);
    }
  }

}

export default TWER_PRELOADER;
